import React from "react"
import { Link } from "react-router-dom"

import { Icon } from "@/components"

import { useStyles } from "@/components/ProfileSection/AssociationCard/AssociationCard.styles"

export const AssociationCard = ({
    customIcon = null,
    icon,
    name,
    subtitle,
    to,
}: {
    customIcon?: React.ReactNode
    icon: string
    name: string
    subtitle?: React.ReactNode
    to: string
}) => {
    const { classes } = useStyles()

    return (
        <div className={classes.container}>
            <div className={classes.icon}>{customIcon || <Icon icon={icon} />}</div>
            <div className={classes.titleWrapper}>
                <Link to={to} className={classes.association}>
                    <span className={classes.name}>{name}</span>
                </Link>
                {subtitle && <div className={classes.subtitle}>{subtitle}</div>}
            </div>
        </div>
    )
}
